import { init as initApm } from "@elastic/apm-rum";

import { getEnvironment, getEnvironmentString } from "utils";

import { appVersions } from "enums";

const envString = getEnvironmentString();
const env = getEnvironment();

export const apm = initApm({
  serviceName: process.env.REACT_APP_ELASTIC_RUM_SERVICE_NAME || "client",
  serverUrl: process.env.REACT_APP_ELASTIC_RUM_SERVER_URL,
  environment: envString || "production",
  serviceVersion: `${appVersions[0].major}.${appVersions[0].minor}`,
  active: !env.local, // turned off in local
  // transactionSampleRate: 1.0,
});
